import React from 'react';
import {Dialog} from "@blueprintjs/core";
import {Link} from 'react-router';
import { ShowIf } from 'components/utils';
import { TrangChu, Reception } from 'api';
import moment from 'moment';
import classNames from 'classnames/bind';
import { Button, Collapse } from "@blueprintjs/core";
import {ThongTinNguoiDungDon, ThongTinNguoiUyQuyen, ThongTinDon, ThongTinCoQuanDaGiaiQuyet, LichSuTrangThaiXuLyGiaiQuyetDon} from 'modules/giai-quyet-don/subView';
import DataTable from 'components/data-table';
import {header} from "constants/table";
import {RowItemListOrganizationPeriodical} from 'modules/reception-periodical/datatable/detail';
import RowItemDocumentDetail from './table-row/RowItemDocumentDetail.jsx';
import TextTruncate from 'react-text-truncate';

class ChiTietDonDialog extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      isOpen: true,
      data: this.props.item,
      isOpenDialog: false,
      donId: this.props.donId,
      dataGiaiQuyet: '',
      trangThaiGiaiQuyet: '',
      dataLichSuTrangThaiXuLyGiaiQuyetDon: [],
      lichSuTrangThaiXLGQDons: [],
    }
  }

  openDialog() {
    Reception.actions.getDonInfo.request({ id: this.props.item.donId }).then(res => {
      if (res.data) {
        this.setState({
          data: {...this.props.item, ...res.data}
        });
      }
    });
    this.getQuyTrinhXuLyHistory(this.props.item.donId);
    this.setState({
      isOpenDialog: !this.state.isOpenDialog
    });
  }

  getQuyTrinhXuLyHistory(inputId) {
    Reception.actions.getLichSuTrangThaiXLGQDons.request({ donId: inputId }).then(res => {
      if (res.data && res.data._embedded) {
        this.setState({ lichSuTrangThaiXLGQDons: res.data._embedded.lichSuTrangThaiXLGQDons });
      } else {
        this.setState({ lichSuTrangThaiXLGQDons: [] });
      }
    })
  }

  closeDialog() {
    this.setState({ isOpenDialog: !this.state.isOpenDialog });
  }

  handleClick() {
    this.setState({isOpen: !this.state.isOpen});
  }

  render() {
    return (
      <div className="wrap-link-todo">
        <Link className="txt-underline" onClick={this.openDialog.bind(this)}>
          <TextTruncate
            line={3}
            truncateText="…"
            text={this.state.data.noiDung}
          />
        </Link>
        <Dialog
          isOpen={this.state.isOpenDialog}
          onClose={this.closeDialog.bind(this)}
          title="THÔNG TIN ĐƠN"
          className="dialog-gh wrap-block chiTietDon-dialog">
          <div className="body-dialog-gh">
            <div className="panel-page">
              <div className="page-wrapper">
                <div className="content-wrap content-gqd background-detail">
                  <div className={classNames('header-redirect background-detail', {'no-border-bottom': !this.state.isOpen})}>
                    <div className="row-col">
                      <ShowIf condition={this.state.data.maHoSo !== ''}>
                        <div className="header-col pl15">
                          <p className="txt-bold">Mã đơn:</p>
                          {this.state.data.maHoSo || ''}
                        </div>
                      </ShowIf>
                      <div className={classNames('header-col', {'pl15': !this.state.data.ma})}>
                        <p className="txt-bold">Ngày tiếp nhận:</p>
                        {this.state.data.ngayTiepNhan ? moment(this.state.data.ngayTiepNhan).format('DD/MM/YYYY') : ''}
                      </div>
                      <div className="header-col">
                        <p className="txt-bold">Nguồn đơn:</p>
                        {this.state.data.nguonDonText}
                      </div>
                      <div className="header-col pr15">
                        <Button onClick={this.handleClick.bind(this)} className={classNames('btn-collap', {'active': this.state.isOpen})} />
                      </div>
                    </div>
                  </div>
                  <ShowIf condition={this.props.coQuanToChucTiepDan && this.props.coQuanToChucTiepDan.length}>
                    <div className="wrapper_box">
                      <div className="box-items mb0-18">
                        <div className="box-forward">
                          <div className="container-box">
                            <div className="group-box pt-20 pl10 pr10">
                              <div className="title">
                                <div className="rows">
                                  <div className="col-12">
                                    <h3>Danh sách cơ quan, các đơn vị cùng tham gia tiếp công dân</h3>
                                  </div>
                                </div>
                              </div>
                              <div className="items-form">
                                <div className="rows">
                                  <div className="col-12">
                                    <DataTable
                                      header = {header.detailReceptionPeriodical.organization}
                                      dataList = {this.props.coQuanToChucTiepDan}
                                      hidePagination = {true}
                                      tableLoading = {false}>
                                      <RowItemListOrganizationPeriodical/>
                                    </DataTable>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </ShowIf>
                  <div className="wrapper_box pb0 pl10 pr10 pt10">
                    <ShowIf condition={this.state.data}>
                      <Collapse isOpen={this.state.isOpen}>
                        <ThongTinNguoiDungDon
                          title ="Thông tin người đứng đơn/vụ việc"
                          {...this.state.data}
                        />
                      </Collapse>
                      <ShowIf condition={this.state.data.coUyQuyen}>
                        <Collapse isOpen={this.state.isOpen}>
                          <div className='box-items mb0 mt20'>
                            <ThongTinNguoiUyQuyen
                              checkTDGS={this.props.checkTDGS}
                              title="Thông tin người được ủy quyền"
                              {...this.state.data}
                            />
                          </div>
                          <div className="pl5 pr5 pt0 mb15"><div className="line-border"></div></div>
                        </Collapse>
                      </ShowIf>
                      <div className={classNames('box-items', {'no-margin': !this.state.isOpen})}>
                          <ThongTinDon
                            checkTDGS={true}
                            title ="Thông tin đơn/Vụ việc"
                            isOpen={this.state.isOpen}
                            {...this.state.data}
                          />
                      </div>
                      <ShowIf condition={this.state.data.coThongTinCoQuanDaGiaiQuyet}>
                        <Collapse isOpen={this.state.isOpen}>
                        <div className="pl5 pr5 pt0 mb15"><div className="line-border"></div></div>
                          <div className={classNames('box-items', {'no-margin': !this.state.isOpen})}>
                            <ThongTinCoQuanDaGiaiQuyet
                              title="Thông tin cơ quan đã giải quyết"
                              {...this.state.data}
                            />
                          </div>
                        </Collapse>
                      </ShowIf>
                    </ShowIf>
                  </div>
                </div>
              </div>
              <ShowIf condition={this.state.lichSuTrangThaiXLGQDons && this.state.lichSuTrangThaiXLGQDons.length}>
                <div className="page-wrapper">
                  <div className="box-items no-border">
                    <div className="box-forward">
                      <div className="title">
                        <div className="rows">
                          <div className="col-12">
                            <h3>Quá trình xử lý</h3>
                          </div>
                        </div>
                      </div>
                      <div className="items-form">
                        <div className="rows">
                          <div className="col-12">
                            <DataTable
                              header={header.listTTXLGQD}
                              dataList={this.state.lichSuTrangThaiXLGQDons}
                              hidePagination={true}>
                              <RowItemDocumentDetail/>
                            </DataTable>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </ShowIf>
            </div>
            <div className="box-bottom mt20">
              <Link className="btn-action btn-close" onClick={this.closeDialog.bind(this)}>
                <span>Đóng</span>
              </Link>
            </div>
          </div>
        </Dialog>
      </div>
    );
  }
}

ChiTietDonDialog.defaultProps = {
  dataGiaiQuyet: [],
  coQuanToChucTiepDan: []
}

export default ChiTietDonDialog;



// WEBPACK FOOTER //
// ./src/components/modules/dialog/ChiTietDonDialog.jsx